import { createFileRoute } from "@tanstack/react-router";
import { VersichertenDetail } from "@/components/versicherte/VersichertenDetail";

export const Route = createFileRoute("/_authenticated/versicherte/$versicherteId")({
  component: VersichertenDetailPage,
});

function VersichertenDetailPage() {
  const { versicherteId } = Route.useParams();
  return <VersichertenDetail versicherteId={versicherteId} />;
}
